<div class="container stretchHeight">
  <div class="row headerRow">
    <h2 class="form-logo" i18n="@@authentication.title.company">LST</h2>
  </div>
  <div class="row login-version">
    <h2 i18n="@@authentication.title.login">Log in</h2>
    <app-version alignment="align-login"></app-version>
  </div>
  <button type="button"
          class="btn btn-primary waves-effect d-block"
          (click)="login()">
    Login
  </button>
  <div *ngIf="showMaintenanceMessage && maintenanceMessage" class="maintenance-message-display">

    <span class="field-value col-sm-3 col-form-label" style="font:bold; color: chartreuse; font-size: x-large;">{{ maintenanceMessage.title }}</span>

    <p class="field-value message-body col-sm-11 col-form-label" style="color: chartreuse;">{{ maintenanceMessage.messageBody }}</p>
    <a *ngIf="maintenanceMessage.urlMoreInfo"
      [href]="maintenanceMessage.urlMoreInfo"
      target="_blank"
      rel="noopener"
      class="more-info">
      {{maintenanceMessage.urlMoreInfo}}
    </a>
  </div>

  <!-- <label for="maintenanceTitle" class="col-sm-3 col-form-label" i18n="@@maintenanceTitle"></label>
  <label for="maintenanceBody" class="col-sm-3 col-form-label" i18n="@@maintenanceBody"></label> -->

</div>
